// src/components/Service.js
import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Airport Cab Service",
    desc: "Convenient airport pickup and drop services with Shivai Travels at affordable prices.",
    image: "/images/services/Airport-Cab-Service.jpg",
    link: "/airport-cab-service"
  },
  {
    id: 2,
    name: "Business Travel Cab Service",
    desc: "Efficient and comfortable cab service designed for business professionals.",
    image: "/images/services/Business-Travel-Cab-Service.jpg",
    link: "/business-travel-cab-service"
  },
  {
    id: 3,
    name: "Corporate Cab Service",
    desc: "Professional corporate cab solutions for meetings, office pickups, and employee transport.",
    image: "/images/services/Corporate-Cab-Service.jpg",
    link: "/corporate-cab-service"
  },
  {
    id: 4,
    name: "Festival & Event Special Rides",
    desc: "Special cab rides for festivals, events, and group travel across Pune and nearby cities.",
    image: "/images/services/Festival-&-Event-Special-Rides.jpg",
    link: "/festival-event-special-rides"
  },
  {
    id: 5,
    name: "Hill Station Travel Service",
    desc: "Comfortable hill station cab rides for vacations and weekend trips.",
    image: "/images/services/Hill-Station-Travel-Service.jpg",
    link: "/hill-station-travel-service"
  },
  {
    id: 6,
    name: "Local City Rides",
    desc: "Fast and reliable local cab rides in Pune for daily travel and city tours.",
    image: "/images/services/Local-City-Rides.jpg",
    link: "/local-city-rides"
  },
  {
    id: 7,
    name: "Luxury Car Rental Service",
    desc: "Luxury cars for weddings, VIP travel, and premium business trips.",
    image: "/images/services/Luxury-Car-Rental-Service.jpg",
    link: "/luxury-car-rental-service"
  },
  {
    id: 8,
    name: "Mumbai Outstation Cab",
    desc: "Reliable Mumbai outstation taxi service for long-distance comfortable travel.",
    image: "/images/services/Mumbai-outstation-cab.jpg",
    link: "/mumbai-outstation-cab"
  },
  {
    id: 9,
    name: "One-Way Drop Service",
    desc: "Affordable one-way taxi rides with transparent pricing and no hidden charges.",
    image: "/images/services/One-Way-Drop-Service.jpg",
    link: "/one-way-drop-service"
  },
  {
    id: 10,
    name: "Outstation Cab Service",
    desc: "Comfortable outstation taxi service from Pune to anywhere in Maharashtra and beyond.",
    image: "/images/services/Outstation-Cab-Service.jpg",
    link: "/outstation-cab-service"
  },
  {
    id: 11,
    name: "Round Trip Taxi Service",
    desc: "Book round-trip cabs with Shivai Travels for family vacations and business travel.",
    image: "/images/services/Round-Trip-Taxi-Service.jpg",
    link: "/round-trip-taxi-service"
  },
  {
    id: 12,
    name: "Wedding & Event Transportation",
    desc: "Premium transportation services for weddings, parties, and special occasions.",
    image: "/images/services/Wedding-&-Event-Transportation.jpg",
    link: "/wedding-event-transportation"
  }
];

const Service = () => {
  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">Services</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    <div className="twm-vehicle-fleet-bx twm-custom-grid-3 ">
                      <div className="twm-media twmtitle">
                        <div className="twm-media-pi borderrr twmtitle text-center">
                          <img src={vehicle.image} alt={vehicle.name} />
                        </div>
                      </div>
                      <div className="twm-vehicle-fleet-content ">
                        <h3 className="twm-v-title twmtitle twmtitle text-center">
                          <a className="twmtitle text-center darkcolo" >{vehicle.name}</a>
                        </h3>
                        <ul className="twm-vehicle-facility">
                          <li>{vehicle.desc}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;